import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';

import { processFormalizacionResponse, processDistributionPledge, formatDistributionData, formatPledgeRelation } from './utils';

const OPERATION_URL = `${API_CONFIG.API}/node/operation`;
const INCLUDEDS_OPERATION = '?include=dates_assigments,notario_operacion';

const PLEDGE_URL = `${API_CONFIG.API}/node/pledge/`;
const INCLUDED_PLEDGE = '?include=distribution_pledge';

const DISTRIBUTION_URL = `${API_CONFIG.API}/node/distribution_pledge`;
export default {
  getData(id) {
    return base.http().get(`${OPERATION_URL}/${id}${INCLUDEDS_OPERATION}`)
      .then(res => processFormalizacionResponse(res.data.included));
  },
  getDistributionByPledge(id) {
    return base.http().get(`${PLEDGE_URL}${id}${INCLUDED_PLEDGE}`)
      .then(res => processDistributionPledge(res.data.included));
  },
  updateDistributionData(data) {
    return base.http().patch(`${DISTRIBUTION_URL}/${data.idDistribution}`, formatDistributionData(data));
  },
  createDistributionData(data) {
    return base.http().post(`${DISTRIBUTION_URL}`, formatDistributionData(data));
  },
  updatePledgeRel(pledge, distribution) {
    return base.http().patch(`${PLEDGE_URL}${pledge.id}`, formatPledgeRelation(pledge, distribution));
  },
};



// WEBPACK FOOTER //
// ./src/features/formalizacion/service.js